import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of } from 'rxjs';
import { ConfigService } from '../config.service';
import { SessionStorageService } from '../storage/session-storage.service';
import { CachingApiService } from './cachingApiService';
import { TripDetail } from './commonInterfaces';
import { DataTransform } from './dataTransformFunctions';
import { BroadcastService } from '../services/broadcast.service';



@Injectable({
  providedIn: 'root'
})
export class LinkableTripsService extends CachingApiService<TripDetail[]> {

  protected broadcastKey: string = "linkable-trips"
  getApiUrl(): string {
    return this.config.dataApiUrl + '/incidents/linkable-trips';
  }

  constructor(
    http: HttpClient,
    config: ConfigService,
    storage: SessionStorageService,
    broadcastService: BroadcastService
  ) {
    super(http, config, storage, broadcastService)
  }

  getLinkableTrips(): Observable<TripDetail[]> {
    return this.getCache().pipe(
      switchMap(cache => {
        return DataTransform.replaceDatesArray(cache.data, [{dateType: "local", fieldName: "tripDate"}, {dateType: "central", fieldName: "dateReserved" }])
      })
    )
  }


}
